/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyCommentFormContainer_comment = {
    readonly id: string;
    readonly site: {
        readonly id: string;
    };
    readonly author: {
        readonly username: string | null;
    } | null;
    readonly revision: {
        readonly id: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ReplyEditedWarningContainer_comment">;
    readonly " $refType": "ReplyCommentFormContainer_comment";
};
export type ReplyCommentFormContainer_comment$data = ReplyCommentFormContainer_comment;
export type ReplyCommentFormContainer_comment$key = {
    readonly " $data"?: ReplyCommentFormContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyCommentFormContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = [
        (v0 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ReplyCommentFormContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "site",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentRevision",
                "kind": "LinkedField",
                "name": "revision",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReplyEditedWarningContainer_comment"
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7eda2a7222dc2a4a945bf398a68bc399';
export default node;
